module.exports = ".map-container {\n    width: 100%;\n    height: 100%;\n}\nsvg {\n    max-width: 100%;\n    max-height: 100%;\n}"